import React from 'react';
import Flag from '../components/ui-components/Flag';

export const getFlagsFromRegions = (
    regions: string[]
): React.ReactNode | Iterable<React.ReactNode> => {
    if (regions && regions.length > 0) {
        if (regions.some((r: string) => r.toLowerCase().includes('worldwide'))) {
            return <Flag flag="worldwide" />;
        }
        if (regions.includes('UK') && regions.includes('EU')) {
            return <Flag flag="eu" />;
        }
        return regions.map((r: string) => (
            <Flag key={r} flag={r.toLowerCase()} />
        ));
    }
};
